import { useState } from "react"
import MTable from "../../../../components/mtable"
import InitialsAvatar from "../../../../components/InitialsAvatar"
import LoadingButton from "../../../../components/LoadingButton"
import { MatchingState } from "../../../../utils/enums"

const PREVIEW_QUERY = { matchStatus: MatchingState.PREVIEW }
const CARD_VIEW_SETTINGS = { minWidth: '100%' }

function MatchParticipant({ user, sub }) {
    return (
        <div className="match-participant">
            <InitialsAvatar firstName={user?.firstName ?? ''} lastName={user?.lastName ?? ''} />
            <div style={{ minWidth: 0 }}>
                <p className="card-label medium ellipsis">{user ? `${user.firstName} ${user.lastName}` : 'Unknown'}</p>
                {sub && <p className="card-label-s neutral ellipsis">{sub}</p>}
            </div>
        </div>
    )
}

export default function ProposedMatchesCard({ programId, actingOn, onApprove, onReject, refreshToken }) {

    const [total, setTotal] = useState(null)

    const mapper = { columns: [
        {
            label: 'Mentor', width: '1fr',
            render: (match) => (
                <MatchParticipant
                    user={match.mentorEnrollment?.user}
                    sub={match.track?.trackName ?? null}
                />
            )
        },
        {
            label: '', width: 'auto',
            render: () => <span className="material-symbols-outlined match-link">sync_alt</span>
        },
        {
            label: 'Mentee', width: '1fr',
            render: (match) => (
                <MatchParticipant
                    user={match.menteeEnrollment?.user}
                    sub={match.track?.trackName ?? null}
                />
            )
        },
        {
            label: 'Actions', width: 'auto',
            render: (match) => {
                const busy = actingOn === match.id
                return (
                    <div className="match-actions">
                        <LoadingButton
                            className={`solid small ${busy ? 'disabled' : ''}`}
                            label="Approve"
                            loading={busy}
                            disabled={busy}
                            onClick={() => onApprove(match.id)}
                        />
                        <button
                            type="button"
                            className={`outline small ${busy ? 'disabled' : ''}`}
                            disabled={busy}
                            onClick={() => onReject(match.id)}
                        >Reject</button>
                    </div>
                )
            }
        },
    ]}

    return (
    <div>
        <div className="flex space-between center wrap gap-xs v-spacer-s">
            <p className="section-title">
                Proposed matches{total != null ? ` · ${total}` : ''}
            </p>
        </div>

        <MTable
            path={`programs/${programId}/matches`}
            queryParams={PREVIEW_QUERY}
            itemsPerPage={10}
            mapper={mapper}
            cardViewSettings={CARD_VIEW_SETTINGS}
            autoHideNavigation={true}
            refreshToken={refreshToken}
            onMeta={(meta) => setTotal(meta?.total ?? 0)}
            emptyState={
                <div className="dashed-card columns standard-padding">
                    <p className="card-title">No proposed matches</p>
                    <p className="card-label neutral v-spacer-s">
                        Run the algorithm to generate proposed matches for review.
                    </p>
                </div>
            }
        />
    </div>
)
}
